import React, { useState } from 'react';

const FileUpload: React.FC<{ onChangeFile: (v: any) => void }> = (props) => {
  const [file, setFile] = useState<any>(null);

  const handleFileChange = (event: any) => {
    const files = event.target.files[0];
    setFile(files);
    props?.onChangeFile(files);
  };

  return (
    <div className="max-w-md mx-auto p-6 bg-white shadow-lg rounded-lg">
      {/* Upload Input */}
      <label className="block">
        <input
          type="file"
          accept=".xlsx"
          onChange={handleFileChange}
          className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-600 file:text-white hover:file:bg-blue-700 cursor-pointer"
        />
      </label>

      {/* File Preview */}
      {file && (
        <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
          <p className="text-gray-800">Selected file: <strong>{file.name}</strong></p>
        </div>
      )}
    </div>
  );
};

export default FileUpload;
